module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', {
    attrs: {
      "title": _vm.detailsTask,
      "withBody": false,
      "withFooter": false,
      "to": {
        name: 'task',
        params: {
          identifier: _vm.task._id.$oid
        }
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_c('span', {
    staticClass: "badge",
    class: _vm.task.status
  }, [_vm._v(_vm._s(_vm.$t(("batch.statuses." + (_vm.task.status) + ".label"))))]), _vm._v(" "), _c('div', {
    staticClass: "form-flex"
  }, [_c('drop', [_c('button', {
    staticClass: "btn",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("\n          Ações "), _c('i', {
    staticClass: "i-caret i-caret--light"
  })]), _vm._v(" "), _c('drop-content', {
    attrs: {
      "slot": "content",
      "placement": "bottom-end"
    },
    slot: "content"
  }, [_c('ul', {
    staticClass: "c-nav c-nav--menus"
  }, [_vm._t("default")], 2)])], 1)], 1)]), _vm._v(" "), (_vm.task.status === 'processing') ? _c('progress', {
    staticClass: "progress progress--sm",
    attrs: {
      "slot": "floor"
    },
    domProps: {
      "value": _vm.percent / 100
    },
    slot: "floor"
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0cb9da2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/batch/TaskCard.vue
// module id = 3401
// module chunks = 0